import React, { memo, useMemo } from 'react';
import dynamic from 'next/dynamic';
import type { ScommesseEsitoTipoBoxProps } from 'components/scommesseEsitoTipoBox/ScommesseEsitoTipoBox';

import { ScommesseEsitoSkeleton } from 'components/scommesseEsitoSkeleton';

export type { ScommesseEsitoTipoBoxProps as ScommesseEsitoTipoBoxType };

export const ScommesseEsitoTipoBox = memo(function Loader(props: ScommesseEsitoTipoBoxProps): JSX.Element {
  const objFallback = useMemo(() => <ScommesseEsitoSkeleton {...props} />, []);

  const Dynamic = useMemo(() => {
    return dynamic<ScommesseEsitoTipoBoxProps>(
      () => import('components/scommesseEsitoTipoBox/ScommesseEsitoTipoBox').then((mod) => mod.ScommesseEsitoTipoBox),
      {
        ssr: false,
        loading: () => objFallback,
      }
    );
  }, [objFallback]);

  if (Dynamic) return <Dynamic suppressHydrationWarning={true} {...(props as any)} />;

  return objFallback;
});